import micro from "../../assets/images/icons/Microsoft-365.svg";
import worksorted from "../../assets/images/icons/worksorted.ico";
import intellifloIcon from "../../assets/images/icons/intelliflo_logo.jpeg";
import zohoIcon from "../../assets/images/zoho.png";
import email from "../../assets/images/icons/email.png";
import monday from "../../assets/images/icons/monday.png";
import calendar from "../../assets/images/icons/google-calendar.svg";
import BusinessIcon from "@mui/icons-material/Business";

export const connectors = [
  {
    name: "Microsoft 365",
    id: "microsoft_365",
    displayCategory: "Productivity Suite",
    capabilities: ["EMAIL", "MEETING", "CALENDAR"],
    description:
      "Connect your Microsoft 365 account for seamless email, calendar, and meeting management. Optional: Enable auto-recording for Teams meetings with advanced setup.",
    icon: micro,
    enabled: true,
    bgColor: "linear-gradient(135deg, #a18cd1, #fbc2eb)",
    fields: [],
    useOAuth: true,
    // Real proof a Microsoft connection actually exists, as opposed to just a
    // Connector doc with status:true. Two legitimate connection methods exist:
    // "orgTenantId" (one-click OAuth, MicrosoftOrgOAuthController.upsertMs365Connector)
    // and "clientId" (legacy manually-entered Azure app, MicrosoftOAuthController /
    // getOrgTenantForUserOAuth's old-model branch) — either one means it's really
    // connected. Used by ConnectorsTabPanel to tell "a Connector doc exists" apart
    // from "Microsoft was actually connected".
    connectionProofKeys: ["orgTenantId", "clientId"],
    subFields: [
      {
        name: "emailEnabled",
        label: "Manage Email",
        type: "switch",
        default: false,
      },
    ],
  },
  {
    name: "Monday.com",
    id: "mondaycom",
    displayCategory: "CRM",
    capabilities: ["CRM"],
    description:
      "A product, offering workspace chat and video conferencing, file storage, and integration of proprietary and third-party applications and services.",
    icon: monday,
    enabled: true,
    bgColor: "linear-gradient(135deg, #FF158A, #FFCB00, #00C853)",
    fields: [
      { name: "MONDAY_BOARD_ID", label: "Monday Board ID", type: "text" },
      { name: "MONDAY_API_TOKEN", label: "Monday API Token", type: "password" },
    ],
  },
  {
    name: "Worksorted",
    id: "worksorted",
    displayCategory: "CRM",
    capabilities: ["CRM"],
    description:
      "A product, offering workspace chat and video conferencing, file storage, and integration of proprietary and third-party applications and services.",
    icon: worksorted,
    enabled: true,
    bgColor: "linear-gradient(135deg, #e0f7fa, #b2ebf2)",
    fields: [
      { name: "clientId", label: "Client ID", type: "text" },
      { name: "clientSecret", label: "Client Secret", type: "password" },
    ],
  },
  {
    name: "AdviserLogic",
    id: "adviserlogic",
    displayCategory: "CRM",
    capabilities: ["CRM"],
    description:
      "Connect your AdviserLogic account to import client contacts and synchronize your existing client database with Prospo.",
    icon: BusinessIcon,
    enabled: true,
    bgColor: "linear-gradient(135deg, #667eea, #764ba2)",
    fields: [
      { name: "keyUserId", label: "API Key (KeyUserId)", type: "text" },
      {
        name: "keyPwdSecret",
        label: "API Password (KeyPwd)",
        type: "password",
      },
      { name: "paramUID", label: "Login ID (paramUID)", type: "text" },
    ],
  },
  // Microsoft Outlook removed from connector cards — toggle is now inside the Microsoft 365 connector settings
  {
    name: "Zoho",
    id: "zoho",
    displayCategory: "CRM",
    capabilities: ["CRM"],
    description:
      "Import your contacts directly from Zoho CRM. Supports Organisation-level configuration and User-level authentication.",
    icon: zohoIcon,
    enabled: true,
    bgColor:
      "linear-gradient(135deg, rgba(66, 133, 244, 0.12) 0%, rgba(52, 168, 83, 0.12) 33%, rgba(251, 188, 5, 0.12) 66%, rgba(234, 67, 53, 0.12) 100%)",
    fields: [
      { name: "clientId", label: "Client ID", type: "text" },
      { name: "clientSecret", label: "Client Secret", type: "password" },
    ],
  },
  {
    name: "Intelliflo",
    id: "intelliflo",
    displayCategory: "CRM",
    capabilities: ["CRM"],
    description:
      "Connect your Intelliflo Office account to sync clients and contacts directly into Prospo.",
    icon: intellifloIcon,
    enabled: true,
    bgColor: "linear-gradient(135deg, #0F172A, #1E40AF)",
    fields: [
      { name: "clientId", label: "Client ID", type: "text" },
      { name: "clientSecret", label: "Client Secret", type: "password" },
      { name: "apiKey", label: "API Key (x-api-key)", type: "password" },
    ],
  },
  {
    name: "Google Calendar",
    id: "google",
    displayCategory: "Email & Calendar",
    capabilities: ["CALENDAR"],
    description:
      "A product, offering workspace chat and video conferencing, file storage, and integration of proprietary and third-party applications and services.",
    icon: calendar,
    enabled: false,
    bgColor: "linear-gradient(135deg, #00c6ff, #fdbb2d)",
    fields: [],
  },
];
